module.exports = __webpack_public_path__ + "static/img/ic_agc.3e3487b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bdm/ic_agc.png
// module id = LbCU
// module chunks = 0